import { createContext, useContext } from "react";
import { stdObject } from "../data/types/stdObject";

export const MainContext = createContext<stdObject>({});
export const useMainContext = () => useContext(MainContext);

export const DocContext = createContext<stdObject>({});
export const useDocContext = () => useContext(DocContext);

export const StationeryContext = createContext<stdObject>({});
export const useStationeryContext = () => useContext(StationeryContext);
